export default __webpack_public_path__ + "images/3d87be732af601e9073e97919ccdb59d.svg";